import { graphql } from 'app/generated/gql'

// Same contract as the REST status payload's `data`, so `adaptRestStatus` maps it unchanged.
export const LOCATION_INTEGRATION_STATUS_QUERY = graphql(`
  query LocationIntegrationStatus($integration: String!, $locationId: ID!) {
    integrationStatus(integration: $integration, locationId: $locationId) {
      status
      completion
      patientsCompletion
      appointmentsCompletion
      transactionsCompletion
      remainingPatients
      remainingAppointments
      remainingTransactions
      remainingCalls
      remainingForms
      remainingSpendRecords
      configuredPages
    }
  }
`)

export const SYNC_JOB_PROGRESS_FRAGMENT = graphql(`
  fragment SyncJobProgress on BackgroundJobProgress {
    id
    jobId
    type
    description
    locationId
    orgId
    totalTasks
    remaining
    completed
    percentComplete
    complete
    createdAt
    completedAt
  }
`)

// The filter takes one type, so each PMS sync gets its own newest-first page. Finished runs are
// included on purpose: a location's newest run decides whether its row shows a bar at all.
export const RECENT_SYNC_JOBS_QUERY = graphql(`
  query RecentSyncJobs($pagination: PaginationInput) {
    kolla: backgroundJobs(
      filter: { type: "kolla-sync" }
      sort: { field: "createdAt", direction: DESC }
      pagination: $pagination
    ) {
      nodes {
        ...SyncJobProgress
      }
    }
    sikka: backgroundJobs(
      filter: { type: "sikka-sync" }
      sort: { field: "createdAt", direction: DESC }
      pagination: $pagination
    ) {
      nodes {
        ...SyncJobProgress
      }
    }
    carestack: backgroundJobs(
      filter: { type: "carestack-sync" }
      sort: { field: "createdAt", direction: DESC }
      pagination: $pagination
    ) {
      nodes {
        ...SyncJobProgress
      }
    }
    ascend: backgroundJobs(
      filter: { type: "ascend-sync" }
      sort: { field: "createdAt", direction: DESC }
      pagination: $pagination
    ) {
      nodes {
        ...SyncJobProgress
      }
    }
  }
`)
